import { render, staticRenderFns } from "./TrxProject.vue?vue&type=template&id=3b65a852&"
import script from "./TrxProject.vue?vue&type=script&lang=js&"
export * from "./TrxProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrxProject.vue"
export default component.exports